class AtiistarsSlider extends HTMLElement {
  selectors = {
    swiper: '[data-js-atiistars-swiper]',
    storySwiper: '[data-js-atiistars-story-swiper]',
    slides: '[data-js-atiistars-slide]',
    stories: '[data-js-atiistars-story]',
    previous: '[data-js-atiistars-previous]',
    next: '[data-js-atiistars-next]'
  };

  connectedCallback() {
    this.swiperElement = this.querySelector(this.selectors.swiper);
    this.storySwiperElement = this.querySelector(this.selectors.storySwiper);
    this.slideElements = [...this.querySelectorAll(this.selectors.slides)];
    this.storyElements = [...this.querySelectorAll(this.selectors.stories)];
    this.previousElement = this.querySelector(this.selectors.previous);
    this.nextElement = this.querySelector(this.selectors.next);

    this.init();
    this.bindEvents();
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.destroy();
  }

  init() {
    if ((!this.swiperElement && !this.storySwiperElement) || this.swiper || typeof Swiper === 'undefined') return;

    this.initStorySwiper();

    if (!this.swiperElement) return;

    const isImageGallery = this.storyElements.length === 0;
    this.swiper = new Swiper(this.swiperElement, {
      initialSlide: isImageGallery && this.slideElements.length > 1 ? 1 : 0,
      slidesPerView: 1,
      spaceBetween: isImageGallery ? 16 : 0,
      centeredSlides: isImageGallery,
      loop: isImageGallery && this.slideElements.length > 3,
      rewind: isImageGallery ? this.slideElements.length > 1 && this.slideElements.length <= 3 : this.slideElements.length > 1,
      autoplay: isImageGallery && this.slideElements.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      breakpoints: isImageGallery ? {
        768: { slidesPerView: this.slideElements.length >= 3 ? 3 : 1, spaceBetween: 24 }
      } : undefined,
      navigation: this.previousElement && this.nextElement ? {
        prevEl: this.previousElement,
        nextEl: this.nextElement
      } : false,
      on: {
        slideChange: this.onSlideChange
      }
    });

    if (this.storySwiper) {
      this.storySwiper.controller.control = this.swiper;
      this.swiper.controller.control = this.storySwiper;
    } else {
      this.showStory(this.swiper.realIndex);
    }
  }

  initStorySwiper() {
    if (!this.storySwiperElement || this.storySwiper) return;

    this.storyElements.forEach((story) => {
      story.hidden = false;
    });

    this.storySwiper = new Swiper(this.storySwiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      rewind: this.storyElements.length > 1,
      speed: 300
    });
  }

  bindEvents() {
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  onSectionLoad = (event) => {
    if (event.detail.sectionId === this.dataset.sectionId) this.init();
  };

  onSlideChange = (swiper) => {
    if (this.storySwiper) return;
    this.showStory(swiper.realIndex);
  };

  onBlockSelect = (event) => {
    if (event.detail.sectionId !== this.dataset.sectionId || !this.swiper) return;

    const selectedIndex = this.slideElements.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
    if (selectedIndex === -1) return;

    this.swiper.autoplay?.stop();
    if (this.swiper.params.loop) this.swiper.slideToLoop(selectedIndex);
    else this.swiper.slideTo(selectedIndex);
  };

  showStory(index) {
    this.storyElements.forEach((story, storyIndex) => {
      const isActive = storyIndex === index;
      story.hidden = !isActive;
      story.classList.toggle('is-active', isActive);
    });
  }

  destroy() {
    this.storySwiper?.destroy(true, true);
    this.storySwiper = null;
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('atiistars-slider')) customElements.define('atiistars-slider', AtiistarsSlider);
